import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { AlertModule } from 'app/components/alert/alert.module';
import { MonthlyTotalsCardSmartComponent } from './monthly-totals-card-smart/monthly-totals-card-smart.component';
import { MonthlyTotalsSmartComponent } from './monthly-totals-smart/monthly-totals-smart.component';
import { AlternateTransactionsComponent } from './alternate-transactions/alternate-transactions.component';
import { DocumentPickerModule } from 'app/document-picker/document-picker.module';
import { MonthlyTotalsCardComponent } from './monthly-totals-card/monthly-totals-card.component';
import { MonthlyTotalsAccountTableComponent } from './monthly-totals-account-table/monthly-totals-account-table.component';
import { BankValuesComponent } from './bank-values/bank-values.component';
import { BankAccountComponent } from './bank-account/bank-account.component';
import { BankAccountAddComponent } from './bank-account-add/bank-account-add.component';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MonthlyTotalsDialogComponent } from './monthly-totals-dialog/monthly-totals-dialog.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AccountDeleteDialogComponent } from './account-delete-dialog/account-delete-dialog.component';
import { BankAccountAddDialogComponent } from './bank-account-add-dialog/bank-account-add-dialog.component';
import { BankAccountCloneDialogComponent } from './bank-account-clone-dialog/bank-account-clone-dialog.component';
import { MatDividerModule } from '@angular/material/divider';

@NgModule({
    declarations: [
        MonthlyTotalsCardSmartComponent,
        MonthlyTotalsSmartComponent,
        AlternateTransactionsComponent,
        MonthlyTotalsCardComponent,
        MonthlyTotalsAccountTableComponent,
        BankValuesComponent,
        BankAccountComponent,
        BankAccountAddComponent,
        MonthlyTotalsDialogComponent,
        AccountDeleteDialogComponent,
        BankAccountAddDialogComponent,
        BankAccountCloneDialogComponent
    ],
    imports: [
        AlertModule,
        CommonModule,
        DocumentPickerModule,
        FormlyMaterialModule,
        FormlyModule,
        MatButtonModule,
        MatInputModule,
        FormsModule,
        MatDialogModule,
        MatDividerModule,
        MatIconModule,
        MatProgressSpinnerModule,
        MatTableModule,
        MatTabsModule,
        ReactiveFormsModule,
        MatTooltipModule,
    ],
    exports: [
        MonthlyTotalsSmartComponent,
        MonthlyTotalsCardSmartComponent,
        BankAccountAddComponent
    ]
})
export class MonthlyTotalsModule { }
